import { css } from 'lit'

export default css`
    :host {
        display: block;
        outline: none;
    }

    input {
        all: unset;
    }

    .input {
        font-weight: var(--font-weight-medium);
        border: 1px solid var(--grey4, black);
        padding: var(--SelectBox-padding, 4px 12px);
        border-radius: 5px;
        background: white;
        color: var(--grey1);
    }

    .input:focus {
        border-color: var(--primary-color) !important;
    }

    .input:hover {
        border-color: var(--grey3);
    }

    .input::placeholder {
        color: var(--grey3);
    }

    .input.is-invalid {
        border-color: var(--negative);
    }

    .input.disabled {
        background: var(--disabled);
        cursor: auto;
        color: #9cabb9;
    }
`
